export function getTotalVolunteerTimes(stencils, numWeeks) {
  let trace = 0,
    carve = 0;

  // For each stencil add up the expected times
  for (const stencil of stencils) {
    // For one week events, add up times fot stencils selected for week 1
    if (numWeeks === 1) {
      if (stencil.isSelectedWeek1) {
        if (stencil.expected_trace_time <= 90)
          trace += Number(stencil.expected_trace_time);
        if (stencil.expected_carve_time <= 90)
          carve += Number(stencil.expected_carve_time);
      }
    }

    // For two week events, add up times fot stencils selected for week 1 or 2
    else if (numWeeks === 2) {
      if (stencil.isSelectedWeek1) {
        if (stencil.expected_trace_time <= 90)
          trace += Number(stencil.expected_trace_time);
        if (stencil.expected_carve_time <= 90)
          carve += Number(stencil.expected_carve_time);
      }
      if (stencil.isSelectedWeek2) {
        if (stencil.expected_trace_time <= 90)
          trace += Number(stencil.expected_trace_time);
        if (stencil.expected_carve_time <= 90)
          carve += Number(stencil.expected_carve_time);
      }
    }

    // For three week events, add up times fot stencils selected for week 1, 2, or 3
    else if (numWeeks === 3) {
      if (stencil.isSelectedWeek1) {
        if (stencil.expected_trace_time <= 90)
          trace += Number(stencil.expected_trace_time);
        if (stencil.expected_carve_time <= 90)
          carve += Number(stencil.expected_carve_time);
      }
      if (stencil.isSelectedWeek2) {
        if (stencil.expected_trace_time <= 90)
          trace += Number(stencil.expected_trace_time);
        if (stencil.expected_carve_time <= 90)
          carve += Number(stencil.expected_carve_time);
      }
      if (stencil.isSelectedWeek3) {
        if (stencil.expected_trace_time <= 90)
          trace += Number(stencil.expected_trace_time);
        if (stencil.expected_carve_time <= 90)
          carve += Number(stencil.expected_carve_time);
      }
    }
  }

  // Convert to hours
  trace /= 60;
  carve /= 60;

  trace = trace.toFixed(2);
  carve = carve.toFixed(2);

  return { trace, carve };
}

/**
 * Function that formats milliseconds into HH:MM:SS or MM:SS
 * @param {Time in milliseconds} ms
 * @returns formatted string of inputted time
 */
export function fmt(ms) {
  const s = Math.floor(ms / 1000);
  const hh = String(Math.floor(s / 3600)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  if (hh > 0) {
    const mm = String(Math.floor((s - hh * 3600) / 60)).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  }
  const mm = String(Math.floor(s / 60)).padStart(2, "0");
  return `${mm}:${ss}`;
}

/**
 * Starts the Timer
 * @param {Int} running
 * @param {Object} stencilWeek
 * @param {Date} startTs 
 * @param {Function} setRunning 
 * @param {Int} setTime
 * @param {Date} tickRef 
 * @param {String} selectedStep 
 * @returns 
 */
export function startTimer(
  running, 
  stencilWeek, 
  startTs, 
  setRunning, 
  setTime, 
  tickRef, 
  selectedStep
) {
  if (running) return;

  // check if the stencil is already in progress:
  if (stencilWeek.trace_start_time && selectedStep === 2 && !running)
    startTs.current = Date.parse(stencilWeek.trace_start_time);
  else if (stencilWeek.carve_start_time && selectedStep === 3 && !running)
    startTs.current = Date.parse(stencilWeek.carve_start_time);
  else startTs.current = Date.now();

  setRunning(true);
  tickRef.current = setInterval(() => {
    setTime(Date.now() - startTs.current);
  }, 200);
}

/**
 * Stops the timer
 * @param {Int} running 
 * @param {Date} tickRef 
 * @param {Function} setTime 
 * @param {Function} setRunning 
 * @returns 
 */
export function stopTimer(
  running, 
  tickRef,
  startTs, 
  setTime, 
  setRunning
) {
  if (!running) return;
  clearInterval(tickRef.current);
  tickRef.current = null;
  const curTime = Date.now() - startTs.current;
  setTime(curTime);
  setRunning(false);
}

/**
 * Resets the timer
 * @param {Function} setTime 
 * @param {Date} startTs 
 * @param {Date} tickRef 
 * @param {Function} setRunning 
 */
export function resetTimer(
  setTime, 
  startTs, 
  tickRef, 
  setRunning
) {
  setTime(0);
  startTs.current = null;
  if (tickRef.current) clearInterval(tickRef.current);
  tickRef.current = null;
  setRunning(false);
}
